import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SharedModule, DialogModule,
         DropdownModule, CheckboxModule, TabViewModule,
         CalendarModule, EditorModule,
         AccordionModule, 
         DataTableModule,
         ListboxModule,
         ButtonModule,
         FieldsetModule,
         GMapModule,
         SpinnerModule,
         InputMaskModule,
         PanelModule,
         PickListModule,
         AutoCompleteModule,
         GrowlModule,
         InputSwitchModule,
         ChipsModule,
         ConfirmDialogModule,
         ChartModule,
         ToggleButtonModule,
         SplitButtonModule,
         SelectButtonModule,
         RadioButtonModule,
         ProgressBarModule,
         TreeModule} from 'primeng/primeng';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        CommonModule,
        DataTableModule,
        SharedModule,
        DialogModule,
        DropdownModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        EditorModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionModule,
        ChipsModule,
        ConfirmDialogModule,

        ChartModule,
        ToggleButtonModule,
        SplitButtonModule,
        AutoCompleteModule,
        SelectButtonModule,
        RadioButtonModule,
        TreeModule,
        ProgressBarModule,
        NgxSkeletonLoaderModule
        
    ],

    exports: [
      TreeModule,
        CommonModule,
        DataTableModule,
        SharedModule,
        DialogModule,
        DropdownModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        EditorModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionModule,
        ListboxModule,
        ButtonModule, FieldsetModule, GMapModule,
        ChipsModule,
        ConfirmDialogModule,
        SpinnerModule, InputMaskModule,
          PanelModule, PickListModule, AutoCompleteModule, GrowlModule,
          InputSwitchModule,


          DataTableModule,
        SharedModule,
        DialogModule,
       
        CheckboxModule,
        CalendarModule,
        PanelModule,
        
        ChartModule,
        ToggleButtonModule,
        SplitButtonModule,
        AutoCompleteModule,
        SelectButtonModule,
        RadioButtonModule,
      
        ProgressBarModule,
        NgxSkeletonLoaderModule

          
        ]
})
export class UISharedModule { }